import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import brandTheme from "brandTheme/Theme";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import ToastModal from "views/components/ToastModal";
import { useDigioLiveness } from "views/components/Digio/DigioSdk";
import { saveUserSelfieDetailsDigitap } from "store/reducers/login/LoginSlice";
import { thirdPartyIntegrationNames } from "assets/properties/properties";
import { thirdPartyIntegrationVendorNames } from "assets/properties/properties";
import { saveSelfieDetails } from "store/reducers/login/LoginSlice";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 40%",
    maxWidth: "31.3%",
    textAlign:'center',
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  nextButton1: {
    boxShadow: "inherit",
    color: brandTheme.white,
    margin: "10px 10px 10px 0",
    padding: "0px 40px",
    height: "40px",
    width: "100px",
    textTransform: "capitalize",
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    "&:hover": {
      background:
        "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    },
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px",
  },
}));

const SelfieDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.login.authData);
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const { mobileNumber } = useSelector((state) => state.login.userData);

  const [panImage, setPanImage] = useState("");
  const [panDataPresent, setPanDataPresent] = useState(false);
  const [callInProgress, setCallInProgress] = useState(false);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");

  const [digioImage, setDigioImage] = useState("");
  const [showSimpleCamera, setShowSimpleCamera] = useState(false);
  // Replace with your values
  const [featureFlags, setFeatureFlags] = useState({});
  const logo = "";
  const customerName = mobileNumber;
  const digitapData = useSelector((state) => state.login.userSelfieDetails);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    getFeatureFlag();
  }, []);
  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    console.log(result?.data, "fsjfsdkjfsdjk");
    setFeatureFlags(result?.data);
  };
  const { startLiveness } = useDigioLiveness({
    customerName,
    mobileNumber,
    logo,
    templateName: featureFlags?.digioTemplateName,
    digioEnvironment: featureFlags?.digioEnvironment,
    setDigioImage,
    setCallInProgress,
  });

  useEffect(() => {
    getUserDocumentDetails();
  }, []);

  useEffect(() => {
    if (digioImage?.file_in_base64) {
      uploadDigioImage();
    }
  }, [digioImage]);

  useEffect(() => {
    if (digitapData?.imageUrl && digitapData?.isLive) {
      uploadDigitapImage(digitapData.imageUrl);
    }
  }, [digitapData]);

  const uploadDigitapImage = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      console.log("Original:", (blob.size / 1024).toFixed(2), "KB");

      const compressedBlob = await compressImage(blob);

      console.log("Compressed:", (compressedBlob.size / 1024).toFixed(2), "KB");

      const file = new File([compressedBlob], "digitap-selfie.jpeg", {
        type: "image/jpeg",
      });

      await uploadSelfieData(file, file.name);
    } catch (error) {
      console.error(error);
    }
  };
  const base64ToBlob = (base64, contentType = "image/jpeg") => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    return new Blob([byteArray], {
      type: contentType,
    });
  };

  const uploadDigioImage = async () => {
    const blob = base64ToBlob(digioImage.file_in_base64, "image/jpeg");

    const compressedBlob = await compressImage(blob);

    uploadSelfieData(compressedBlob, "selfie.jpeg");
  };

  const getUserDocumentDetails = async (type) => {
    setCallInProgress(true);

    const result = await apiHandler({
      url: endpoint.GET_LEAD_ALL_DOCUMENTS_API + leadId + "/documents",
      method: "GET",
      authToken,
    });

    setCallInProgress(false);

    if (result?.data?.customerPhotoLink) {
      setPanImage(result.data.customerPhotoLink);

      if (type) {
        setPanDataPresent(false);
      } else {
        setPanDataPresent(true);
      }
    }
  };
  const compressImage = (blob, quality = 0.6, maxWidth = 720) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = URL.createObjectURL(blob);

      img.onload = () => {
        const canvas = document.createElement("canvas");

        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (compressedBlob) => {
            resolve(compressedBlob);
          },
          "image/jpeg",
          quality
        );
      };
    });
  };
  const uploadSelfieData = async (blob, fileName) => {
    setCallInProgress(true);

    const formData = new FormData();

    formData.append("file", blob, fileName);
    formData.append("leadApplicationId", leadId);

    const res = await apiHandler({
      url: endpoint.USER_UPLOAD_SELFIE_API,
      method: "POST",
      authToken,
      data: formData,
    });

    setCallInProgress(false);

    if (res?.data?.error_code || res?.data === "" || res?.data?.error) {
      toastUpdate(
        "Error",
        res?.data?.user_description || "There is an error, Please try again",
        true
      );
    } else {
      toastUpdate("Success", "Image Uploaded Successfully", true);

      getUserDocumentDetails("firstTime");
    }
  };

  const handleNext = () => {
    dispatch(saveSelfieDetails({}));
    navigate("/journey/GeneralDetails");
  };
  const GetThirdPartyData = async () => {
    const result = await apiHandler({
      url: endpoint.CHECK_THIRD_PARTY_INTEGRATION,
      authToken,
    });

    if (Array.isArray(result?.data)) {
      const faceLiveNessIntegration = result.data.find(
        (integration) =>
          integration?.integration === thirdPartyIntegrationNames?.faceLiveNess
      );

      return {
        enabled: faceLiveNessIntegration?.enabled || false,
        vendor: faceLiveNessIntegration?.vendor || "",
      };
    }

    return {
      enabled: false,
      vendor: "",
    };
  };
  const onClickCamera = async () => {
    const faceLiveness = await GetThirdPartyData();

    if (!faceLiveness?.enabled) {
      setShowSimpleCamera(true);
      return;
    }

    setShowSimpleCamera(false);

    if (faceLiveness?.vendor === thirdPartyIntegrationVendorNames?.digitap) {
      onDigitapLiveness();
    } else if (
      faceLiveness?.vendor === thirdPartyIntegrationVendorNames?.digio
    ) {
      startLiveness();
    } else {
      setShowSimpleCamera(true);
    }
  };
  const onDigitapLiveness = async () => {
    setCallInProgress(true);
    //ADMIN_LOANACCOUNTNUMBER;
    const res = await apiHandler({
      url: endpoint.FACE_LIVENESS_INIT,
      method: "POST",
      authToken: authToken,
      data: {
        sourceId: leadId,
        callbackurl: window.location.origin + "/journey/selfie-liveness",
        vendor: "DIGITAP",
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      if (res?.data?.redirectUrl) {
        dispatch(
          saveUserSelfieDetailsDigitap({
            leadId,
          })
        );
        window.location.href = res?.data?.redirectUrl;
      }
    }
  };
  const handleCameraError = (error) => {
    console.log("handleCameraError", error);
  };

  const handleCameraStart = (stream) => {
    console.log("handleCameraStart", stream);
  };

  const handleCameraStop = () => {
    console.log("handleCameraStop");
  };

  const handleTakePhoto = async (dataUri, type) => {
    try {
      const blob = await fetch(dataUri).then((res) => res.blob());

      const compressedBlob = await compressImage(blob);

      await uploadSelfieData(compressedBlob, `${type}.jpeg`);

      setShowSimpleCamera(false);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader
          label="Selfie"
        />
      </Grid>

      <Grid item xs={12}>
        <Grid container style={{textAlign:'center', margin:'2%'}}>
          {/* {!panDataPresent && ( */}
          <Grid item xs={12}>
            <Button
              size="small"
              onClick={onClickCamera}
              className={classes.nextButton1}
            >
              Camera
            </Button>
          </Grid>
          {/* )} */}
        </Grid>
        {showSimpleCamera && (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 20,
            }}
          >
            <Camera
              style={{
                width: "40vh",
                height: "40vh",
              }}
              onTakePhoto={(dataUri) => {
                handleTakePhoto(dataUri, "photo");
              }}
              onCameraError={(error) => {
                handleCameraError(error);
              }}
              isMaxResolution={true}
              isFullscreen={false}
              sizeFactor={2}
              onCameraStart={(stream) => {
                handleCameraStart(stream);
              }}
              onCameraStop={() => {
                handleCameraStop();
              }}
            />
          </Grid>
        )}
        {!showSimpleCamera && panImage && (
          <Grid container className={classes.imageContainer}>
            <img src={panImage} width="350" height="350" alt="Selfie" />
          </Grid>
        )}
      </Grid>
        <Grid item xs={12}>
        <BottomButton
          button1={"Next"}
          button1click={handleNext}
          disabled1={!panImage}
        />
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default SelfieDetails;
